export const Well = ({ children }: { children: JSX.Element }) => (
  <div className="space-y-6 border bg-white p-3 sm:rounded-3xl sm:border-ebony-clay-100 sm:p-6 sm:shadow-sm">
    {children}
  </div>
);
